import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import Table from "../../../../../../Components/Table";
import {
    CadatrarAgendaAcaoEtapaReguaController,
    DeletarAgendaAcaoEtapaReguaController,
    GetAgendaAcaoEtapaReguaController,
} from "../../../../../../Controllers/Automacao/Regua/GestaoDeRegua/GestaoDeReguaControllers";
import {
    IAcoesReguaEtapa,
    IEtapaAcaoAgendamento,
} from "../../../../../../Interfaces/Automacao/Regua/GestaoDeRegua/GestaoDeReguaInterfaces";

interface IProps {
    row: IAcoesReguaEtapa;
}

interface IFormData {
    DT_ENVIO: string;
}

export default function ModalAgendamento(props: IProps) {
    const { register, handleSubmit, formState, reset } = useForm();
    const [LstAgendamento, setLstAgendamento] =
        useState<Array<IEtapaAcaoAgendamento>>();
    moment.locale("pt-br");
    const dataLocal = new Date();
    const offsetLocal = dataLocal.getTimezoneOffset();
    const offsetMilliseconds = offsetLocal * 60 * 1000;
    const dataUTC = new Date(dataLocal.getTime() + offsetMilliseconds);
    const offsetBrasilia = -6 * 60 * 60 * 1000;
    const dataBrasilia = new Date(dataUTC.getTime() + offsetBrasilia);
    const stringISOBrasilia = dataBrasilia.toISOString();

    const updateList = useCallback(
        () =>
            GetAgendaAcaoEtapaReguaController(
                props.row.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO
            ).then((res) => {
                setLstAgendamento(res);
            }),
        [props.row.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO]
    );

    useEffect(() => {
        updateList();
    }, [updateList]);

    function handleFormSubmit(formData: IFormData) {
        CadatrarAgendaAcaoEtapaReguaController({
            DT_ENVIO: formData.DT_ENVIO,
            ID_CASO_COBRANCA_REGUA_ETAPA_ACAO:
                props.row.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO,
        }).then(() => {
            updateList();
            reset();
        });
    }

    const rowTable = (cell: any, row: IEtapaAcaoAgendamento) => {
        return <div>{moment(row.DT_ENVIO).format("DD/MM/yyyy - HH:mm")}</div>;
    };

    const rowExec = (cell: any, row: IEtapaAcaoAgendamento) => {
        return <div>{row.FL_ENVIADO ? "Sim" : "Não"}</div>;
    };

    const rowDelete = (cell: any, row: IEtapaAcaoAgendamento) => {
        return (
            <div className="d-flex justify-content-center align-itens-center">
                <button
                    type="button"
                    className="btn  btn-sm btn-outline-danger font-weight-bold"
                    onClick={() => {
                        Swal.fire({
                            title: "Deseja apagar este agendamento?",
                            icon: "info",
                            buttonsStyling: false,
                            confirmButtonText:
                                "<i class='la la-check'></i> Sim!",
                            showCancelButton: true,
                            cancelButtonText:
                                "<i class='la la-thumbs-down'></i> Não",
                            customClass: {
                                confirmButton: "btn btn-outline-success",
                                cancelButton: "btn btn-default",
                            },
                        }).then((result) => {
                            if (result.isConfirmed) {
                                row.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_AGENDA &&
                                    DeletarAgendaAcaoEtapaReguaController(
                                        row.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_AGENDA
                                    ).then(() => updateList());
                            }
                        });
                    }}
                >
                    <FontAwesomeIcon icon={faTrash} size="lg" />
                </button>
            </div>
        );
    };

    const columns: Array<ColumnDescription> = [
        {
            dataField: "ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_AGENDA",
            text: "Data de Execução",
            formatter: rowTable,
            headerClasses: "font-size-h8 font-weight-bold",
            classes: "p-3 ws-nowrap",
        },
        {
            dataField: "ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_AGENDA",
            text: "Executado",
            formatter: rowExec,
            headerClasses: "font-size-h8 font-weight-bold",
            classes: "p-3 ws-nowrap",
        },
        {
            dataField: "ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_AGENDA",
            text: "Deletar",
            formatter: rowDelete,
            headerClasses: "font-size-h8 font-weight-bold",
            classes: "p-3 ws-nowrap",
        },
    ];

    return (
        <div>
            <form
                onSubmit={handleSubmit(handleFormSubmit)}
                className="w-100 d-flex justify-content-between align-itens-center mb-3"
            >
                <div className="w-100 h-100">
                    <h6>Data e horário do disparo:</h6>
                    <div className="d-flex flex-wrap flex-row">
                        <input
                            type="datetime-local"
                            aria-disabled
                            min={stringISOBrasilia.substring(0, 16)}
                            name="DT_ENVIO"
                            className={`form-control w-75 placeholder-dark-45 ${
                                formState.errors.DT_ENVIO && "is-invalid"
                            } mr-2`}
                            defaultValue={stringISOBrasilia.substring(0, 16)}
                            ref={register({
                                required: "Insira o nome da etapa",
                            })}
                        />
                        <button className="btn btn-outline-success font-weight-bold d-flex justify-content-center align-items-center">
                            <FontAwesomeIcon
                                icon={faPlus}
                                size="lg"
                                className="mr-1"
                            />{" "}
                            Salvar Disparo
                        </button>
                    </div>
                    <div className="mt-8">
                        {LstAgendamento && (
                            <Table
                                columns={columns}
                                data={LstAgendamento}
                                keyField={
                                    "ID_CASO_COBRANCA_REGUA_ETAPA_ACAO_AGENDA"
                                }
                                noSearch

                                //loading={Loading}
                            />
                        )}
                    </div>
                </div>
            </form>
        </div>
    );
}
